import * as React from 'react';
/**
 *
 * Original name: home
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1057
 *
 */
export const HomeLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M20.594 9.414 12 2.54 3.406 9.414l.938 1.171L5.5 9.66V19h5v-4.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75V19h5V9.66l1.157.925.937-1.17ZM17 17.5h-2v-3.25A2.25 2.25 0 0 0 12.75 12h-1.5A2.25 2.25 0 0 0 9 14.25v3.25H7V8.46l5-4 5 4v9.04Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
